// ========================================
// Dr. Costi House of Beauty - Main JavaScript
// ========================================

// ========================================
// Data: Products & Flowers
// ========================================
const PRODUCTS = [
  {
    id: 1,
    handle: 'essential-indulgence',
    title: 'Essential Indulgence',
    price: 200,
    description: 'Perfect for birthdays, thank-yous, or a thoughtful gesture. Unlock a world of rejuvenating facials and skincare essentials.',
    imageUrl: 'images/voucher-200.jpg',
    boxUrl: 'images/gift-card-box.png',
    isPopular: false,
    features: [
      'Premium facial treatment',
      'Skincare consultation',
      'Product recommendations',
      'Flexible booking'
    ],
    idealFor: 'Perfect for birthdays & thank yous'
  },
  {
    id: 2,
    handle: 'signature-supremacy',
    title: 'Signature Supremacy',
    price: 600,
    description: 'Our most beloved tier—ideal for someone truly special. A generous credit for transformative treatments and personalized care.',
    imageUrl: 'images/voucher-600.jpg',
    boxUrl: 'images/gift-card-box.png',
    isPopular: true,
    features: [
      'Multiple premium treatments',
      'VIP consultation session',
      'Priority booking access',
      'Complimentary touch-ups'
    ],
    idealFor: "Valentine's Favorite - Most Popular"
  },
  {
    id: 3,
    handle: 'ultimate-transformation',
    title: 'Ultimate Transformation',
    price: 400,
    description: 'For anniversaries or milestones deserving of something extraordinary. Advanced treatments await.',
    imageUrl: 'images/voucher-400.jpg',
    boxUrl: 'images/gift-card-box.png',
    isPopular: false,
    features: [
      'Advanced treatment options',
      'Personalized treatment plan',
      'Extended consultation',
      'Aftercare products included'
    ],
    idealFor: 'For anniversaries & milestones'
  }
];

const FLOWERS = [
  {
    id: 'flower-185',
    name: 'Rose Elegance',
    originalPrice: 185,
    price: 167,
    savings: 18,
    image: 'images/flowers/185.jpg'
  },
  {
    id: 'flower-250',
    name: "Valentine's Blush",
    originalPrice: 250,
    price: 225,
    savings: 25,
    image: 'images/flowers/250.jpg'
  },
  {
    id: 'flower-265',
    name: 'Pink Perfection',
    originalPrice: 265,
    price: 239,
    savings: 26,
    image: 'images/flowers/265.jpg'
  },
  {
    id: 'flower-300',
    name: 'Grand Romance',
    originalPrice: 300,
    price: 270,
    savings: 30,
    image: 'images/flowers/300.jpg'
  },
  {
    id: 'flower-700',
    name: 'Ultimate Love',
    originalPrice: 700,
    price: 630,
    savings: 70,
    image: 'images/flowers/700.jpg'
  }
];

// ========================================
// Cart State Management (localStorage)
// ========================================
const Cart = {
  KEY: 'drcosti_cart',
  
  getItems() {
    try {
      const data = localStorage.getItem(this.KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },
  
  saveItems(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
    this.updateCartCount();
  },
  
  addItem(item) {
    const items = this.getItems();
    items.push({
      ...item,
      cartId: Date.now() + Math.random()
    });
    this.saveItems(items);
  },
  
  removeItem(cartId) {
    const items = this.getItems().filter(item => item.cartId !== cartId);
    this.saveItems(items);
  },
  
  updateQuantity(cartId, quantity) {
    const items = this.getItems();
    const item = items.find(i => i.cartId === cartId);
    if (item) {
      item.quantity = Math.max(1, quantity);
      this.saveItems(items);
    }
  },
  
  clear() {
    localStorage.removeItem(this.KEY);
    this.updateCartCount();
  },
  
  getTotal() {
    return this.getItems().reduce((sum, item) => {
      const itemTotal = (item.price * item.quantity) + (item.addon ? item.addon.price : 0);
      return sum + itemTotal;
    }, 0);
  },
  
  getCount() {
    return this.getItems().reduce((sum, item) => sum + item.quantity, 0);
  },
  
  updateCartCount() {
    const countEl = document.querySelector('.cart-count');
    if (countEl) {
      const count = this.getCount();
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }
};

// ========================================
// Header Scroll Effect
// ========================================
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
}

// ========================================
// Gift Card Image Toggle (3 second cycle)
// ========================================
function initGiftCardToggle() {
  const cards = document.querySelectorAll('.gift-card-image');
  if (cards.length === 0) return;
  
  let showBox = false;
  
  setInterval(() => {
    showBox = !showBox;
    cards.forEach(card => {
      const voucherImg = card.querySelector('.voucher-img');
      const boxImg = card.querySelector('.box-img');
      if (voucherImg && boxImg) {
        voucherImg.style.opacity = showBox ? '0' : '1';
        boxImg.style.opacity = showBox ? '1' : '0';
      }
    });
  }, 3000);
}

// ========================================
// Flower Carousel (5 second auto-scroll)
// ========================================
function initFlowerCarousel() {
  const slides = document.querySelectorAll('.flower-slide');
  const dots = document.querySelectorAll('.carousel-dot');
  const prevBtn = document.querySelector('.carousel-nav.prev');
  const nextBtn = document.querySelector('.carousel-nav.next');
  
  if (slides.length === 0) return;
  
  let currentIndex = 0;
  let autoScrollTimer;
  
  function showSlide(index) {
    currentIndex = (index + slides.length) % slides.length;
    
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === currentIndex);
    });
    
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentIndex);
    });
  }
  
  function nextSlide() {
    showSlide(currentIndex + 1);
  }
  
  function prevSlide() {
    showSlide(currentIndex - 1);
  }
  
  function startAutoScroll() {
    autoScrollTimer = setInterval(nextSlide, 5000);
  }
  
  function resetAutoScroll() {
    clearInterval(autoScrollTimer);
    startAutoScroll();
  }
  
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoScroll();
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoScroll();
    });
  }
  
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      showSlide(i);
      resetAutoScroll();
    });
  });
  
  slides.forEach(slide => {
    slide.addEventListener('click', () => {
      const flowerId = slide.dataset.flowerId;
      if (flowerId) {
        window.location.href = `product.html?addon=${flowerId}`;
      }
    });
  });
  
  showSlide(0);
  startAutoScroll();
}

// ========================================
// Bundle Builder
// ========================================
function initBundleBuilder() {
  const giftCardOptions = document.querySelectorAll('.bundle-option[data-type="giftcard"]');
  const flowerOptions = document.querySelectorAll('.bundle-option[data-type="flower"]');
  const totalDisplay = document.querySelector('.bundle-total-value');
  const bundleBtn = document.querySelector('.bundle-cta');
  
  let selectedGiftCard = null;
  let selectedFlower = null;
  
  function updateTotal() {
    let total = 0;
    if (selectedGiftCard) total += selectedGiftCard.price;
    if (selectedFlower) total += selectedFlower.price;
    if (totalDisplay) {
      totalDisplay.textContent = total > 0 ? `$${total}` : '$0';
    }
  }
  
  giftCardOptions.forEach(option => {
    option.addEventListener('click', () => {
      giftCardOptions.forEach(o => o.classList.remove('selected'));
      option.classList.add('selected');
      selectedGiftCard = PRODUCTS.find(p => p.id === parseInt(option.dataset.productId));
      updateTotal();
    });
  });
  
  flowerOptions.forEach(option => {
    option.addEventListener('click', () => {
      if (option.classList.contains('selected')) {
        option.classList.remove('selected');
        selectedFlower = null;
      } else {
        flowerOptions.forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
        selectedFlower = FLOWERS.find(f => f.id === option.dataset.flowerId);
      }
      updateTotal();
    });
  });
  
  if (bundleBtn) {
    bundleBtn.addEventListener('click', () => {
      if (!selectedGiftCard) {
        alert('Please select a gift card first');
        return;
      }
      let url = `product.html?product=${selectedGiftCard.handle}`;
      if (selectedFlower) {
        url += `&addon=${selectedFlower.id}`;
      }
      window.location.href = url;
    });
  }
}

// ========================================
// FAQ Accordion
// ========================================
function initFAQ() {
  const faqItems = document.querySelectorAll('.faq-item');
  
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      faqItems.forEach(i => i.classList.remove('open'));
      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });
}

// ========================================
// Product Page Functions
// ========================================
function initProductPage() {
  const quantityMinus = document.querySelector('.quantity-minus');
  const quantityPlus = document.querySelector('.quantity-plus');
  const quantityDisplay = document.querySelector('.quantity-display');
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  const flowerSelect = document.getElementById('flowerAddon');
  
  let quantity = 1;
  
  if (quantityMinus) {
    quantityMinus.addEventListener('click', () => {
      if (quantity > 1) {
        quantity--;
        quantityDisplay.textContent = quantity;
        updatePrice();
      }
    });
  }
  
  if (quantityPlus) {
    quantityPlus.addEventListener('click', () => {
      quantity++;
      quantityDisplay.textContent = quantity;
      updatePrice();
    });
  }
  
  function updatePrice() {
    const priceDisplay = document.querySelector('.product-price');
    const productPrice = parseFloat(priceDisplay?.dataset.basePrice || 0);
    let addonPrice = 0;
    
    if (flowerSelect && flowerSelect.value) {
      const flower = FLOWERS.find(f => f.id === flowerSelect.value);
      if (flower) addonPrice = flower.price;
    }
    
    const total = (productPrice * quantity) + addonPrice;
    if (priceDisplay) {
      priceDisplay.textContent = `$${total}`;
    }
  }
  
  if (flowerSelect) {
    flowerSelect.addEventListener('change', updatePrice);
  }
  
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const recipientName = document.getElementById('recipientName')?.value || '';
      const senderName = document.getElementById('senderName')?.value || '';
      const message = document.getElementById('message')?.value || '';
      const deliveryDate = document.getElementById('deliveryDate')?.value || '';
      
      const productHandle = new URLSearchParams(window.location.search).get('product') || 'signature-supremacy';
      const product = PRODUCTS.find(p => p.handle === productHandle) || PRODUCTS[1];
      
      let addon = null;
      if (flowerSelect && flowerSelect.value) {
        addon = FLOWERS.find(f => f.id === flowerSelect.value);
      }
      
      Cart.addItem({
        productId: product.id,
        title: product.title,
        price: product.price,
        imageUrl: product.imageUrl,
        quantity: quantity,
        recipientName,
        senderName,
        message,
        deliveryDate,
        addon
      });
      
      window.location.href = 'cart.html';
    });
  }
}

// ========================================
// Cart Page Functions
// ========================================
function initCartPage() {
  renderCartItems();
  Cart.updateCartCount();
}

function renderCartItems() {
  const cartContainer = document.querySelector('.cart-items-list');
  const cartEmpty = document.querySelector('.cart-empty');
  const cartContent = document.querySelector('.cart-content');
  const subtotalEl = document.querySelector('.subtotal-value');
  const totalEl = document.querySelector('.total-value');
  
  const items = Cart.getItems();
  
  if (items.length === 0) {
    if (cartEmpty) cartEmpty.style.display = 'block';
    if (cartContent) cartContent.style.display = 'none';
    return;
  }
  
  if (cartEmpty) cartEmpty.style.display = 'none';
  if (cartContent) cartContent.style.display = 'grid';
  
  if (cartContainer) {
    cartContainer.innerHTML = items.map(item => `
      <div class="cart-item" data-cart-id="${item.cartId}">
        <div class="cart-item-image">
          <img src="${item.imageUrl}" alt="${item.title}">
        </div>
        <div class="cart-item-details">
          <h4>${item.title}</h4>
          ${item.recipientName ? `<p class="cart-item-personalization">To: ${item.recipientName}${item.senderName ? ` from ${item.senderName}` : ''}</p>` : ''}
          ${item.addon ? `<span class="cart-item-addon"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg> ${item.addon.name} (+$${item.addon.price})</span>` : ''}
          <div class="cart-item-quantity">
            <button class="quantity-btn" onclick="updateCartQuantity(${item.cartId}, ${item.quantity - 1})">−</button>
            <span class="quantity-display">${item.quantity}</span>
            <button class="quantity-btn" onclick="updateCartQuantity(${item.cartId}, ${item.quantity + 1})">+</button>
          </div>
        </div>
        <div class="cart-item-price">
          <div class="cart-item-total">$${(item.price * item.quantity) + (item.addon ? item.addon.price : 0)}</div>
          <div class="cart-item-unit">$${item.price} each</div>
          <button class="cart-item-remove" onclick="removeCartItem(${item.cartId})">Remove</button>
        </div>
      </div>
    `).join('');
  }
  
  const subtotal = Cart.getTotal();
  if (subtotalEl) subtotalEl.textContent = `$${subtotal}`;
  if (totalEl) totalEl.textContent = `$${subtotal}`;
}

function updateCartQuantity(cartId, quantity) {
  if (quantity < 1) {
    removeCartItem(cartId);
    return;
  }
  Cart.updateQuantity(cartId, quantity);
  renderCartItems();
}

function removeCartItem(cartId) {
  Cart.removeItem(cartId);
  renderCartItems();
}

// ========================================
// Smooth Scroll for Anchor Links
// ========================================
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

// ========================================
// Initialize on DOM Ready
// ========================================
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initSmoothScroll();
  Cart.updateCartCount();
  
  if (document.querySelector('.gift-card-image')) {
    initGiftCardToggle();
  }
  
  if (document.querySelector('.flower-carousel')) {
    initFlowerCarousel();
  }
  
  if (document.querySelector('.bundle-section')) {
    initBundleBuilder();
  }
  
  if (document.querySelector('.faq-section')) {
    initFAQ();
  }
  
  if (document.querySelector('.product-page')) {
    initProductPage();
  }
  
  if (document.querySelector('.cart-page')) {
    initCartPage();
  }
});

// Make functions globally available for inline onclick handlers
window.updateCartQuantity = updateCartQuantity;
window.removeCartItem = removeCartItem;
